export enum OrderOriginTypeEnum {
    Client = 0,
    Analyst,
    AnalystReplaced
}